import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './EvaluationCriteria.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import RowEvaluationCriteria from './RowEvaluationCriteria/RowEvaluationCriteria'
import AddEvaluationCriteriaModal from './AddEvaluationCriteriaModal/AddEvaluationCriteriaModal'
import useLocalization from '../../../../hooks/useLocalization'

const initPagination = {
  page: 1,
  limit: 10,
}

const EvaluationCriteria = () => {
  const [evaluationCriteria, setEvaluationCriteria] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'reports',
    dict: {
      evaluation_criteria: 'Evaluation criteria',
      add_criterion: 'Add criterion',
      edit: 'Edit',
      delete: 'Delete',
      entries: 'Entries',
      name: 'Name',
      serial_number: 'Serial number',
      company: 'Company',
      cancel: 'Cancel',
      save: 'Save',
    },
  })

  const fetchCriteria = () => {
    superAxiosRequest({
      method: 'get',
      link: 'progress_report/evaluation',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setEvaluationCriteria(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchCriteria()
  }, [pagination])

  const addCriteria = () => {
    const ms = {
      modalBodyComponent: () => (
        <AddEvaluationCriteriaModal translate={translate} />
      ),
      button: translate.save,
      link: 'progress_report/evaluation',
      title: translate.add_criterion,
      isResponsive: true,
      onSubmitSuccess: () => {
        fetchCriteria()
      },
      valid: {
        name: 'required',
        order: 'required',
        company: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editCriteria = (data) => {
    const ms = {
      modalBodyComponent: () => <AddEvaluationCriteriaModal />,
      button: 'Save',
      link: `progress_report/evaluation/${data?.id}`,
      title: translate.add_criterion,
      isResponsive: true,
      is_put: true,
      onSubmitSuccess: (data) => {
        setEvaluationCriteria((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        order: 'required',
        company: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteCriteria = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the criteria?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `progress_report/evaluation/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setEvaluationCriteria((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editCriteria(items)],
      ['delete', () => deleteCriteria(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.evaluation_criteria}>
          <HeaderAddButton
            title={translate.add_criterion}
            onClick={addCriteria}
          />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {evaluationCriteria?._meta?.count_items}
          </div>
          <div>
            {evaluationCriteria?.result?.map((criteria, index) => (
              <RowEvaluationCriteria
                key={criteria.id}
                criteria={criteria}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {evaluationCriteria?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={evaluationCriteria._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default EvaluationCriteria
